import template from './alertCard.html';
import controller from './alertCard.controller';
import './alertCard.scss';

let alertCardComponent = {
  restrict: 'E',
  transclude: true,
  bindings: {
    isMobileApp: '<',
    alertStyle:'@',
    disabledClose:'<'
  },
  template,
  controller
};

export default alertCardComponent;


// WEBPACK FOOTER //
// ./client/app/components/alertCard/alertCard.component.js